module.exports = __webpack_public_path__ + "static/media/next-course-history-disabled.e1e401b0.svg";